import React, { useEffect, useState } from 'react';
import { Form, Typography, message, Row, Select } from 'antd';
import GenericModal from '../../../buttons/genericModal';
import { backendGetRequest, backendPatchWithoutRefresh } from '../../../../helpers/callBackend';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const { Text } = Typography;
const { Option } = Select

function BankAccountToEntitySetRelation(props) {
	const [modalVisible, setModalVisible] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [expectedAccountCount, setExpectedAccountCount] = useState(-1);
	const [availableBankAccounts, setAvailableBankAccounts] = useState(props.bankAccounts || []);
	const [isLoadingBankAccounts, setIsLoadingBankAccounts] = useState(true);
	const [hasInitializedBankAccounts, setHasInitializedBankAccounts] = useState(false);

	useEffect(() => {
		if (expectedAccountCount < 0) return;
		setIsLoadingBankAccounts(expectedAccountCount > availableBankAccounts.length)
	}, [availableBankAccounts, expectedAccountCount]);

	useEffect(() => {
		if (modalVisible && !hasInitializedBankAccounts) {
			fetchUnassignedBankAccounts();
		}
	}, [modalVisible, hasInitializedBankAccounts]);

	const fetchUnassignedBankAccounts = () => {
		backendGetRequest("/api/bank-account/", {
			params: {
				entity_id: -1,
				page_index: 0,
			}
		}).then((res) => {
			if (res.data.total_records === 0) {
				setExpectedAccountCount(0);
				setHasInitializedBankAccounts(true);
				return;
			}
			
			const totalRecords = res?.data?.total_records || 0;
			setExpectedAccountCount(totalRecords);
			
			for (let i = 1; i <= res?.data?.total_pages; i++) {
				backendGetRequest("/api/bank-account/", {
					params: {
						entity_id: -1,
						page_index: i,
					}
				}).then((pageRes) => {
					setAvailableBankAccounts((prevState) => {
						const newAccounts = [...(prevState || []), ...(pageRes?.data?.associated_bank_accounts || [])];
						if (newAccounts.length >= totalRecords) {
							setHasInitializedBankAccounts(true);
						}
						return newAccounts;
					});
				});
			}
		});
	};

	const onFormSubmitModal = (values) => {
		let data = {
			bank_account_ids: values.bankAccounts,
			entity_id: props.entityId,
		}
		setIsSubmitting(true);
		backendPatchWithoutRefresh("/api/entity/bank-account/relation/", data)
			.then((res) => {
				setModalVisible(false);
				setIsSubmitting(false);
				props.addBankAccounts(res.data.bank_accounts);
			}).catch((err) => {
				setIsSubmitting(false);
			})
	};

	return (
		<GenericModal
			size='md'
			visible={modalVisible}
			handleCancelModal={() => setModalVisible(false)}
			showModal={() => setModalVisible(true)}
			button={<Button disableElevation fullWidth size="small"
				variant={props.buttonVariant || "outlined"}
				color={props.buttonColor || "secondary"}
				sx={{ fontSize: 14, width: '200px', textTransform: 'none' }} style={{ marginRight: "10px" }}> Assign Bank Account(s)
			</Button>}
			modalTitle={`Assign Bank Account(s) to ${props.entityName}`}
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>
					<Row style={{ marginBottom: "20px" }}>
						<Text>
							The following accounts are not assigned to a legal entity. Please select the bank accounts that should be assigned to {props.entityName}.
						</Text>
					</Row>
					<Form.Item
						name={"bankAccounts"}
					>
						<Select
							placeholder={isLoadingBankAccounts ? "Loading available bank accounts..." : "Select bank account(s)"}
							allowClear
							showSearch
							optionFilterProp="children"
							mode="multiple"
							disabled={isLoadingBankAccounts}
							loading={isLoadingBankAccounts}
						>
							{availableBankAccounts.map((account) => (
								<Option key={account.id} value={account.id}>
									{`${account.account.bank.name} / ${account.account.account_description}`}
								</Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item>
						<LoadingButton
							htmlType="submit"
							loading={isSubmitting}
							loadingPosition="start"
							style={{ margin: "3px", width: "100%" }}
							disableElevation fullWidth size="small" type="submit"
							variant="contained"
							color="primary"
							sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
						>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	)
}

export default BankAccountToEntitySetRelation;